'use strict';

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return (0, _from2.default)(arr); } }

var argsAtIndexes = function argsAtIndexes() {
  for (var _len = arguments.length, indexes = Array(_len), _key = 0; _key < _len; _key++) {
    indexes[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return indexes.map(function (idx) {
      return args[idx];
    }).join('_');
  };
};

exports.default = function (originalValue) {
  if (typeof originalValue === 'function') {
    return originalValue;
  } else if (typeof originalValue === 'string') {
    return function () {
      return originalValue;
    };
  } else if (typeof originalValue === 'number') {
    return argsAtIndexes(originalValue);
  } else if (Array.isArray(originalValue)) {
    return argsAtIndexes.apply(undefined, _toConsumableArray(originalValue));
  }

  return null;
};